import React from "react";
import PropTypes from "prop-types";
import styles from "components/documents/active-filter-item.scss";

export const ActiveFilterItem = ({ name, onRemove }) => (
  <div className={ styles.container }>
    { name }
    { renderRemoveButton(name, onRemove) }
  </div>
);

ActiveFilterItem.defaultProps = {
  onRemove: null
};

ActiveFilterItem.propTypes = {
  name: PropTypes.string.isRequired,
  onRemove: PropTypes.func // (name: string) => void
};

const deleteButtonOnClick = (name, callback) => () => callback(name);

const renderRemoveButton = (name, onRemove) => {
  if (onRemove === null) {
    return null;
  }
  return <button className={ styles["remove-button"] } onClick={ deleteButtonOnClick(name, onRemove) } />;
};



// WEBPACK FOOTER //
// ./src/js/components/documents/filters/active-filter-item.jsx